import BreadcrumbItemTitle from './BreadcrumbItemTitle';

export default BreadcrumbItemTitle;
